import {
  Button,
  Icon,
  InlineStack,
  List,
  ListItem,
  Modal,
  ModalBody,
  ModalFooter,
  Strong,
  Text,
  type PlumaManagedModalProps,
} from '@customerio/pluma-components/react';
import { isEmptyString } from '@/utils/string';

export type QueryReviewModalData = {
  name: string;
  databaseName: string;
  /** "people", as the workspace names them. */
  peoplePlural: string;
  /** The Query tab, asked to run the query on arrival. */
  testQueryHref: string;
};

/**
 * Shown after a settings save moved the identifier or the database: the settings are saved, and
 * the query may need to follow. Managed modal; everything it shows comes in as data.
 */
export function QueryReviewModal({
  data,
  onConfirm,
  onClose,
  modalState,
}: PlumaManagedModalProps<QueryReviewModalData>) {
  const { name, databaseName, peoplePlural, testQueryHref } = data;
  return (
    <Modal state={modalState} title="Sync settings have changed" onClose={onClose} data-test-query-review-modal>
      <ModalBody>
        <List styleType="none" gap="200">
          <ListItem>
            <InlineStack alignBlock="start" gap="100">
              <Icon name="check-circle" color="success" />
              <Text>
                <Strong>{isEmptyString(name) ? 'This sync' : name}'s</Strong> settings have been updated
              </Text>
            </InlineStack>
          </ListItem>
          <ListItem>
            <InlineStack alignBlock="start" gap="100">
              <Icon name="caution" color="caution" />
              <Text>
                Your query may need changes to continue syncing {peoplePlural} from your <Strong>{databaseName}</Strong>{' '}
                database.
              </Text>
            </InlineStack>
          </ListItem>
        </List>
      </ModalBody>
      <ModalFooter>
        <Button variant="tertiary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" href={testQueryHref} onClick={onConfirm} data-test-sql-import-button="review-query">
          Test query
        </Button>
      </ModalFooter>
    </Modal>
  );
}
